module.exports = __webpack_public_path__ + "img/delete.a261e7f5.svg";